import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SalaryRule  {
    _originalTypeClassName = "zERP.BO.SalaryRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SalaryRule.translate = translateService;
}
this.AvailableSalaryPeriods = [];
this.RelatedBasicSalaries = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.Description = null;
this.DateFrom = null;
this.Priority = null;
this.IsActive = false;
this.ParameterValue = null;
this.PercentageFMY = null;
this.PercentageIKA = null;
this.PercentageOGA = null;
this.PercentageTaxOffice = null;
this.PercentageOtherDeductions = null;
this.Notes = null;
this.OpenPeriodHandling = null;
this.CalculationMethod = null;
this.RuleType = null;
this.TaxType = null;
this.TaxTypeMultiply = null;
this.IsIndependentTaxation = false;
this.ParticipatesInBonusIncrease = false;
this.ParticipatesInAllowanceIncrease = false;
this.HistoricVariableHandlingOption = null;
this.NotIncludedOnContributions = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Description:any;
DateFrom:any;
Priority:any;
IsActive:any;
ParameterValue:any;
PercentageFMY:any;
PercentageIKA:any;
PercentageOGA:any;
PercentageTaxOffice:any;
PercentageOtherDeductions:any;
Notes:any;
OpenPeriodHandling:any;
CalculationMethod:any;
RuleType:any;
TaxType:any;
TaxTypeMultiply:any;
IsIndependentTaxation:any;
ParticipatesInBonusIncrease:any;
ParticipatesInAllowanceIncrease:any;
HistoricVariableHandlingOption:any;
NotIncludedOnContributions:any;
AvailableSalaryPeriods:any;
RelatedBasicSalaries:any;
CalculationScale:any;
CalculationExpression:any;
AADECode:any;
APDCode:any;
TaxTypeCalculatedExpression:any;
AccountingConfig:any;
ParameterVariable:any;
OutputVariable:any;
static setAvailableSalaryPeriods = ($this, items) => {
                if (items == null) items = [];
                if ($this.AvailableSalaryPeriods == null) $this.AvailableSalaryPeriods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AvailableSalaryPeriods.length > 0) {
                    Domain.SalaryRule.removeAvailableSalaryPeriods($this, $this.AvailableSalaryPeriods[0]);
                }

                Domain.SalaryRule.addManyAvailableSalaryPeriods($this, copyItems);
            }
static addManyAvailableSalaryPeriods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SalaryRule.addAvailableSalaryPeriods($this, items[i]);
                }
            }
static addAvailableSalaryPeriods = ($this, item) => {
                if ($this.AvailableSalaryPeriods == null) $this.AvailableSalaryPeriods = [];
                if (item == null || $this.AvailableSalaryPeriods.indexOf(item) > -1) return;
                $this.AvailableSalaryPeriods.push(item);
}
static addRangeAvailableSalaryPeriods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SalaryRule.addAvailableSalaryPeriods($this, item));
            }
static removeAvailableSalaryPeriods = ($this, item) => {
                if ($this == null || $this.AvailableSalaryPeriods == null || $this.AvailableSalaryPeriods.indexOf(item) === -1) return;
                var _index = $this.AvailableSalaryPeriods.indexOf(item);
                $this.AvailableSalaryPeriods.splice(_index, 1);
}
static clearAvailableSalaryPeriods = ($this) => { $this.AvailableSalaryPeriods = null; }
static setRelatedBasicSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.RelatedBasicSalaries == null) $this.RelatedBasicSalaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.RelatedBasicSalaries.length > 0) {
                    Domain.SalaryRule.removeRelatedBasicSalaries($this, $this.RelatedBasicSalaries[0]);
                }

                Domain.SalaryRule.addManyRelatedBasicSalaries($this, copyItems);
            }
static addManyRelatedBasicSalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SalaryRule.addRelatedBasicSalaries($this, items[i]);
                }
            }
static addRelatedBasicSalaries = ($this, item) => {
                if ($this.RelatedBasicSalaries == null) $this.RelatedBasicSalaries = [];
                if (item == null || $this.RelatedBasicSalaries.indexOf(item) > -1) return;
                $this.RelatedBasicSalaries.push(item);
}
static addRangeRelatedBasicSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SalaryRule.addRelatedBasicSalaries($this, item));
            }
static removeRelatedBasicSalaries = ($this, item) => {
                if ($this == null || $this.RelatedBasicSalaries == null || $this.RelatedBasicSalaries.indexOf(item) === -1) return;
                var _index = $this.RelatedBasicSalaries.indexOf(item);
                $this.RelatedBasicSalaries.splice(_index, 1);
}
static clearRelatedBasicSalaries = ($this) => { $this.RelatedBasicSalaries = null; }
static setCalculationScale = ($this, value) => {
var oldValue = $this.CalculationScale;
$this.CalculationScale = value;
if (value != null) {
}
}
static setCalculationExpression = ($this, value) => {
var oldValue = $this.CalculationExpression;
$this.CalculationExpression = value;
if (value != null) {
}
}
static setAADECode = ($this, value) => {
var oldValue = $this.AADECode;
$this.AADECode = value;
if (value != null) {
}
}
static setAPDCode = ($this, value) => {
var oldValue = $this.APDCode;
$this.APDCode = value;
if (value != null) {
}
}
static setTaxTypeCalculatedExpression = ($this, value) => {
var oldValue = $this.TaxTypeCalculatedExpression;
$this.TaxTypeCalculatedExpression = value;
if (value != null) {
}
}
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}
static setParameterVariable = ($this, value) => {
var oldValue = $this.ParameterVariable;
$this.ParameterVariable = value;
if (value != null) {
}
}
static setOutputVariable = ($this, value) => {
var oldValue = $this.OutputVariable;
$this.OutputVariable = value;
if (value != null) {
}
}

static IsAvailable($this: any, payroll: any,availabeFrom: any,availableTo: any): any{if ($this?.IsActive == false) {return false;}
if (!(Domain.DateHelper.IsDateNull($this?.DateFrom)) && (new Date($this?.DateFrom).getTime()) > (new Date(payroll?.Period?.From).getTime())) {return false;}
if (!(Domain.DateHelper.IsDateNull(availabeFrom)) && (new Date(new Date(new Date(availabeFrom)?.setHours(0, 0, 0, 0))).getTime()) > (new Date(payroll?.Period?.From).getTime())) {return false;}
if (!(Domain.DateHelper.IsDateNull(availableTo)) && (new Date(new Date(new Date(availableTo)?.setHours(0, 0, 0, 0))).getTime()) < (new Date(payroll?.Period?.From).getTime())) {return false;}
if (CLMS.Framework.Number.Equal(() => $this.AvailableSalaryPeriods.length, () => 0)) {return true;}
return $this?.AvailableSalaryPeriods?.linq?.any((s) => s == payroll?.Type);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}